<script setup lang="ts">
const props = defineProps<{
	image?: string
	text: string
	authorImage?: string
	authorName?: string
}>();
</script>

<template>
	<div class="flex flex-col justify-center gap-4 p-6 bg-white h-full">
		<img v-if="props.image" :src="props.image" alt="" class="w-full h-auto rounded-t-2xl" />
		<p class="text-sm text-black text-start my-0 text-pretty" v-html="props.text"></p>
		<div class="flex gap-4 items-center mt-auto">
			<img v-if="props.authorImage" :src="props.authorImage" alt="" class="w-20 h-20 object-cover rounded-full" />

			<div class="flex flex-col gap-1">
				<p class="font-semibold !text-base text-black text-start my-0" v-html="props.authorName"></p>
				<p class="flex items-center gap-2 !text-xs text-white bg-green-500 px-2 py-1 rounded-md text-start my-0">
					<Icon
						name="ph:check"
						class="text-white h-4 w-4"
					/>
					Verified Buyer
				</p>
			</div>
		</div>
	</div>
</template>
